import { apitrigger, axiosFunc } from "../shared/common";
import config from '../config'
import { Decryptdata, Encryptdata } from "../shared/screatkeeper";



export const getOpenSeaNfts = async (data) => {
    const senddata = {
        method: 'POST',
        url: `${config.BACK_URL}/opensea/loadmore`,
        data:  data
    }
    let Resp = await axiosFunc(senddata)
    return Resp.data
}



export const NFTGameInfo = async (data) => {
    const senddata = {
        method: 'POST',
        url: `${config.BACK_URL}/game/nft/gameinfo`,
        data:  data
    }
    let Resp = await axiosFunc(senddata)
    return Resp.data
}